module.exports = __webpack_public_path__ + "static/img/goujia.f2fedfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goujia.png
// module id = MBjJ
// module chunks = 1